import React from "react";
import QueryString from "qs";
import { GetServerSideProps, NextPage } from "next";
import LeadershipDetailsPage from "@/Components/pages/LeadershipPage/detail";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;
export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { res } = ctx;
  const slug = ctx.params?.slug as string;

  if (process.env.NEXT_PUBLIC_CACHE_PAGES && res) {
    res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59"
    );
  }

  if (
    slug === "our-leadership-teams" ||
    slug === "our-leadership-team" ||
    slug === "our-leadership" ||
    slug === null ||
    slug === undefined
  ) {
    return {
      redirect: {
        permanent: true,
        destination: "/our-leadership",
      },
    };
  }

  let apiResData = null;
  const isNew = true;

  try {
    const query = QueryString.stringify(
      {
        filters: { slug: { $eq: slug } },
        populate: "deep,all",
      },
      { encodeValuesOnly: true }
    );

    const apiRes = await fetch(`${baseUrl}our-leadership-teams?${query}`);
    apiResData = await apiRes.json();
    if (!apiResData?.data?.length) return { notFound: true };
    // const service = apiResData?.data?.[0];
    // isNew = service?.attributes;
  } catch (err) {
    console.error("Error fetching service data:", err);
  }

  return {
    props: {
      apiResData,
      isNew,
      slug,
    },
  };
};
interface LeadershipProps {
  isNew: boolean;
  slug: string;
  apiResData: any;
}
const Leadership: NextPage<LeadershipProps> = ({
  /* isNew, slug, */ apiResData,
}) => {
  const data = apiResData?.data?.[0]?.attributes;
  return (
    <div id="root">
      <LeadershipDetailsPage data={data} /* isNew={isNew} slug={slug} */ />
    </div>
  );
};

export default Leadership;
